import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { Icon, IconButton } from "../../components/ui";
import { useEntitlement } from "../../contexts";
import { requireResponse } from "@/core/errors/requireResponse";

const BrandBanner = ({ brand, onBrandSelect, isExpanded }) => {
  const onToggle = () => {
    if (isExpanded) {
      onBrandSelect(null);
    } else {
      onBrandSelect(brand.name);
    }
  };

  return (
    <div className="listing-card f-flex">
      <div className="body d-flex justify-content-between competitive-analysis-banner">
        <div className="d-flex">
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            className="text-warning mx-2 my-auto"
            size="3x"
          />
          <div className="align-self-center">
            <p>{brand.name}</p>
            <label style={{ textTransform: "none", textAlign: "left" }}>
              Review price for {brand.count} listing
              {brand.count !== 1 ? "s" : ""}
            </label>
          </div>
        </div>
        <IconButton
          className="align-self-center mx-2"
          label={`${isExpanded ? "Hide" : "Show"} ${brand.name} listings to review`}
          pressed={isExpanded}
          data-btn="listing-review-toggle"
          onClick={onToggle}
        >
          <Icon name={isExpanded ? "ChevronUp" : "ChevronDown"} size="sm" />
        </IconButton>
      </div>
    </div>
  );
};

const CompetitiveAnalysisBanner = ({ setFilter, setBrand }) => {
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [loading, setLoading] = useState(false);
  // Intelligence add-on (Feature 10): don't render — or even ask for — the
  // competitive-analysis data when the store's plan doesn't include it.
  const hasCompCheck = useEntitlement("competitive_pricing_check");

  useEffect(() => {
    if (!hasCompCheck) return;
    fetchMissingAnalysisData();
  }, [hasCompCheck]);

  const fetchMissingAnalysisData = async () => {
    try {
      setLoading(true);
      const { data } = requireResponse(
        await axios.get("/api/listings/competitive-analysis/missing")
      );
      setBrands(Array.isArray(data?.brands) ? data.brands : []);
    } catch (error) {
      console.error("Failed to fetch competitive analysis data:", error);
      // Hide the banner when the load fails. This used to be `setBrands()`,
      // which stored undefined, and the `!brands.length` check below then
      // crashed the whole listings page.
      setBrands([]);
    } finally {
      setLoading(false);
    }
  };

  const onBrandSelect = (brandName) => {
    if (brandName === null) {
      setSelectedBrand(null);
      setBrand(null);
    } else {
      setSelectedBrand(brandName);
      setBrand(brandName);
    }
  };

  if (!hasCompCheck || loading || !brands.length) {
    return null;
  }

  return (
    <div className="competitive-analysis-banners">
      <div className="card mb-2">
        <div className="body d-flex">
          {brands.map((brand, i) => (
            <div
              key={brand.name}
              className={`col-4 ${i !== brands.length - 1 ? "pr-20" : ""}`}
            >
              <BrandBanner
                brand={brand}
                onBrandSelect={onBrandSelect}
                isExpanded={selectedBrand === brand.name}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompetitiveAnalysisBanner;
